module.exports = __webpack_public_path__ + "img/max_packages.7d50413f.svg";